export const swatches = [
  [
    '#FFC8C8',
    '#FFECC7',
    '#FFFFC8',
    '#C8FFC8',
    '#C8FFFF',
    '#C8C8FF',
    '#FFC8FF',
    '#C8C8C8',
    '#FFFFFF',
  ],
  [
    '#FF6464',
    '#FFC552',
    '#FFFF64',
    '#64FF64',
    '#64FFFF',
    '#6464FF',
    '#FF64FF',
    '#A0A0A0',
    '#F5F5F5',
  ],
  [
    '#FF0000',
    '#FFAA00',
    '#FFF600',
    '#00FF00',
    '#00CCFF',
    '#0000FF',
    '#FF00FF',
    '#787878',
    '#EBEBEB',
  ],
  [
    '#D70000',
    '#D78200',
    '#D7CE00',
    '#00D700',
    '#00A4D7',
    '#0000D7',
    '#D700D7',
    '#505050',
    '#E1E1E1',
  ],
  [
    '#AF0000',
    '#AF5A00',
    '#AFA600',
    '#00A500',
    '#007CAF',
    '#0000AF',
    '#AF00AF',
    '#282828',
    '#D7D7D7',
  ],
  [
    '#870000',
    '#873200',
    '#877E00',
    '#007D00',
    '#005487',
    '#000087',
    '#870087',
    '#000000',
    '#CDCDCD',
  ],
];
